import * as React from "react";

const SKELETON_COUNT = 6;

const SkeletonCard: React.FC = () => {
  return (
    <div className="instant-search-skeleton-card">
      <div className="instant-search-skeleton-image">
        <div className="skeleton-shimmer" />
      </div>
      <div className="instant-search-skeleton-meta">
        <div className="instant-search-skeleton-title">
          <div className="skeleton-shimmer" />
        </div>
        <div className="instant-search-skeleton-price">
          <div className="skeleton-shimmer" />
        </div>
      </div>
    </div>
  );
};

export const InstantSearchSkeleton: React.FC = () => {
  const skeletons = Array.from({ length: SKELETON_COUNT }, (_, index) => (
    <SkeletonCard key={`instant-skeleton-${index}`} />
  ));

  return <div className="instant-search-skeleton-grid">{skeletons}</div>;
};
